import { Proxy } from 'utils';

export function* abortUploadEffect() {
  yield Proxy.uploadXHR.abort();
}
